module.exports.default = {
    "ORDER": "",
    "SCHEDULE.YOU_ARE_ALL_SET": "",
    "SCHEDULE.YOUR_DELIVERY_IS_SCHEDULED_FOR": "",
    "SCHEDULE.CUSTOMER_#_MESSAGE": "",
    "SCHEDULE.SCHEDULE_NOW": "",
    "SCHEDULE.DELIVERY_STATUS_UPDATES": "",
    "SCHEDULE.EMAIL_UPDATES": "",
    "SCHEDULE.SMS_UPDATES": "",
    "SCHEDULE.DISABLE_UPDATES": "",
    "SCHEDULE.STATUS_UPDATE_IN_THE_FOLLOWING": "",
    "OOPS": "",
    "SOMETHING_WENT_WRONG": "",
    "REFRESH": "",
    "PAGE_NOT_FOUND": "",
    "COULD_NOT_FIND_PAGE": "",
    "TRACKING.MESSAGE_DRIVER_FAILED": "",
    "TRACKING.MESSAGE_DRIVER_PLACEHOLDER": "",
    "TRACKING.SEND": "Trimite prin messenger",
    "TRACKING.ARRIVING_AT": "",
    "TRACKING.ETA": "Timp estimat de sosire",
    "TRACKING.MIN": "",
    "TRACKING.MAP": "Trafic",
    "TRACKING.SATELLITE": "Satelit",
    "TRACKING.TERRAIN": "Teren",
    "TRACKING.DRIVER_ARRIVED_MESSAGE": "Salut, am ajuns!",
    "TRACKING.DRIVER_ARRIVED_AT_MESSAGE": "a sosit la",
    "COMPLETED": "Nu ai nicio livrare activă în acest moment",
    "RATING.SKIP": "Nu acum",
    "RATING.WHAT_WENT_WELL": "",
    "RATING.WHAT_WENT_WRONG": "",
    "RATING.THANK_YOU": "",
    "RATING.FOR_USING_OUR_SERVICE": "Mulţumim că aţi apelat la serviciile noastre!",
    "RATING.HOW_WAS_YOUR_DELIVERY": "",
    "RATING.WHAT_WAS_YOUR_EXPERIENCE": "Vă rugăm ajutaţi-ne să ne îmbunătăţim serviciile lăsând o recenzie",
    "SCHEDULE.RATE_US": "Trimite!",
    "TERM_OF_USE": "Termenii serviciului",
    "PRIVACY_POLICY": "Politica de confidenţialitate",
    "SHARING_MY_LOCATION": "Localizează-mă",
    "SHARING_LOADING": "Se încarcă",
    "REQUIRED_FIELD_MESSAGE": "Toate câmpurile sunt obligatorii",
    "CONTACT_NAME": "Nume contact",
    "PHONE_NUMBER": "Număr de telefon",
    "EMAIL_ADDRESS": "Adresă de email",
    "SEND": "Trimite",
    "FORWARD.THIS_ORDER": "Redirecţionează această livrare",
    "FORWARD.TO_CONTACT": "Redirecţionează către contact",
    "FORWARD.ARE_YOU_SURE_MESSAGE": "Eşti sigur că vrei să redirecţionezi această comandă?",
    "FORWARDED.HAS_DELIVERY_FORWARDED_DELIVERY": "",
    "FORWARDED.ARE_YOU_SURE_MESSAGE": "Eşti sigur că vrei să refuzi livrarea?",
    "ACCEPT": "Acceptă",
    "REJECT": "",
    "PICKUP.SET_PICKUP_TIME": "",
    "PICKUP.IVE_ARRIVED": "",
    "PICKUP.PICKUP_ETA_SET_FAILED": "",
    "PICKUP.ETA_SET_FAILED_DESCRIPTION": "",
    "PICKUP.MIN": "",
    "PICKUP.SHOW_THIS_NUMBER": "",
    "PICKUP.IM_OUTSIDE": "",
    "PICKUP.LET_THEM_KNOW_YOUR_OUTSIDE?": "",
    "PICKUP.I_WILL_ARRIVE_AT": "",
    "PICKUP.PICKUP_ETA_SUCCESSFULLY_SET": "",
    "PICKUP.IN": "",
    "PICKUP.TO": "",
    "PICKUP.COLLECT": "",
    "PICKUP.SELECT_METHOD_OF_TRANSPORT": "",
    "PICKUP.CONFIRM_METHOD_OF_TRANSPORT": "",
    "PICKUP.CANCEL": "",
    "PICKUP.CONFIRM_TIME": "",
    "TRACKING.DRIVER_ROUTE_ONE_STOP_MESSAGE": "",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART2": "",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART1": "",
    "PICKUP.OK": "",
    "PICKUP.NEXT": "",
    "PICKUP.SKIP": "",
    "CAR_ARRIVED.TITLE": "",
    "CAR_ARRIVED.PARKING_SPOT": "",
    "CAR_ARRIVED.LICENSE_PLATE": "",
    "CAR_ARRIVED.VEHICLE_MODEL": "",
    "CAR_ARRIVED.VEHICLE_COLOR": "",
    "CAR_ARRIVED.REMEMBER": "",
    "CAR_ARRIVED.PARKING_SPOT_EXAMPLE": "",
    "CAR_ARRIVED.LICENSE_PLATE_EXAMPLE": "",
    "CAR_ARRIVED.VEHICLE_MODEL_EXAMPLE": "",
    "CAR_ARRIVED.VEHICLE_COLOR_EXAMPLE": "",
    "REDIRECT_PICKUP.TO": "",
    "REDIRECT_PICKUP.CONFIRM_TITLE": "",
    "REDIRECT_PICKUP.SUCCESS_TITLE": "",
    "REDIRECT_PICKUP.FAILED_TITLE": "",
    "REDIRECT_PICKUP.FAILED_DESCRIPTION": "",
    "REDIRECT_PICKUP.OK": "",
    "REDIRECT_PICKUP.KM": "",
    "REDIRECT_PICKUP.SELECT_PICKUP_LOCATION": "",
    "REDIRECT_PICKUP.SET_AS_PICKUP_LOCATION": "",
    "REDIRECT_PICKUP.PICKUP_OPTIONS": "",
    "SOON": "",
    "TRACKING.WANT_TO_CALL_YOUR_DRIVER": "",
    "GLOBAL.CALL": "",
    "GLOBAL.CANCEL": "",
    "﻿PICKUP.SET_PICKUP_TIME": "",
    "RATING.PROOF_OF_DELIVERY_MESSAGE": "",
    "SCHEDULED.THANKS_FOR_USING": "",
    "SCHEDULED.SHIPMENT_IN_TRANSIT": "",
    "SCHEDULED.YOUR_DELIVERY_IS_SCHEDULED_FOR": "",
    "Submit": "",
    "RATING.SELECT_STARS_BEFORE_SUBMIT": "",
    "PICKUP.SHOW_ID": "",
    "TRACKING.ESTIMATED_TIME_ARRIVAL": "",
    "OPEN_MENU": "",
    "CLOSE_MENU": "",
    "MAP_AUTO_CENTER": "",
    "MAP_SETTINGS": "",
    "ZOOM_OUT": "",
    "ZOOM_IN": "",
    "TRACKING.CALL_DRIVER": "",
    "TRACKING.MESSAGE_DRIVER": "",
    "PICKUP.SELECT_TIME_TO_CONFIRM": "",
    "PICKUP.SET_OR_ARRIVE_DESCRIPTION": "",
    "SCHEDULE.TIME_ZONE_TEXT": "",
    "TRACKING.THANKS_MESSAGE_SUBTITLE": "",
    "TRACKING.THANKS_MESSAGE_TEXT": "",
    "TRACKING.THANKS_MESSAGE_TITLE": "",
    "TRACKING.CLICK_COLLECT_MESSAGE_TEXT": "",
    "CANCEL_ORDER": "",
    "CANCELLATION_VALIDATION_TITLE": "",
    "CANCELLATION_VALIDATION_BACK": "",
    "CANCELLATION_VALIDATION_YES": "",
    "CANCEL_SUCCESS": "",
    "CANCEL_PAST_ALLOWED": "",
    "CANCEL_ERROR": "",
    "RATING.FREE_TEXT_COMMENT": "",
    "RATING.ORDER_DELIVERED_GREEN": "",
    "CX_ORDER_STATUS.CONFIRMED": "",
    "CX_ORDER_STATUS.RECEIVED": "",
    "CX_ORDER_STATUS.FINDING_DRIVER": "",
    "CX_ORDER_STATUS.DRIVER_FOUND": "",
    "CX_ORDER_STATUS.PICKING_UP": "",
    "CX_ORDER_STATUS.WAY_TO_PICKUP": "",
    "CX_ORDER_STATUS.ON_PREVIOUS_DELIVERY": "",
    "CX_ORDER_STATUS.WAY_TO_DROPOFF": "",
    "CX_ORDER_STATUS.ARRIVED": "",
    "TRACKING.DELIVERY_STATUS_TITLE": "",
    "CONFIGURATION.TAGS.SHOW_DELIVERY_STATUS": "",
    "CONFIRM": "",
    "FLOW_OPTIONS.TITLE": "",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_LABEL": "",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_TEXT": "",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_LABEL": "",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_TEXT": "",
    "RATING_STAR_ALT": "",
    "RATING_STAR_ALT_ONE": "",
    "RATING_STAR_ALT_TWO": "",
    "TRACKING.ARRIVING_IN_ARIA_LABEL": "",
    "TRACKING.MAP_CONTAINER_ARIA_LABEL": "",
    "SCHEDULE.EXTERNAL_ID_INFO": "",
    "SCHEDULE.TASK_NOTE_LABEL": "",
    "SCHEDULE.CANCEL_NOTE_INPUT": "",
    "DELIVERY_WAS_CANCELLED": "",
    "QUESTIONNAIRE.SKIP": "",
    "QUESTIONNAIRE.SKIP_VALIDATION_HEADER": "",
    "QUESTIONNAIRE.SKIP_VALIDATION_MESSAGE": "",
    "QUESTIONNAIRE.BACK": "",
    "QUESTIONNAIRE.SUBMIT_FAILED": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS": "",
    "QUESTIONNAIRE.NA_VALUE": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS_TITLE": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS_MESSAGE": "",
    "QUESTIONNAIRE.PROGRESS_BAR_TITLE": "",
    "QUESTIONNAIRE.NEXT": "",
    "QUESTIONNAIRE.INVALID_FORMAT": "",
    "RESCHEDULE.NEED_A_DIFFERENT_TIME": "",
    "RESCHEDULE.RESCHEDULE_YOUR_DELIVERY": "",
    "RESCHEDULE.GREETING": "",
    "RESCHEDULE.FIRST_AVAILABLE": "",
    "RESCHEDULE.SAME_DAY": "",
    "RESCHEDULE.PICK_A_DATE": "",
    "RESCHEDULE.NEAREST_WINDOWS": "",
    "RESCHEDULE.WINDOWS_FOR_DATE": "",
    "RESCHEDULE.WHICH_DATE": "",
    "RESCHEDULE.NO_WINDOWS": "",
    "RESCHEDULE.NO_WINDOWS_AVAILABLE": "",
    "RESCHEDULE.SOMETHING_WENT_WRONG": "",
    "RESCHEDULE.TRY_AGAIN": "",
    "RESCHEDULE.BACK_TO_START": "",
    "RESCHEDULE.BACK_TO_DELIVERY": "",
    "RESCHEDULE.CONFIRMED": "",
    "RESCHEDULE.TYPE_A_MESSAGE": "",
    "RESCHEDULE.TODAY": ""
};
	